const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { resultClosed } = require('actions/glossary');
require('./GlossaryDefinitionTab.scss');


const GlossaryDefinitionTab = ({ closeResult, selectedResult }) => (
    <div
        className="glossary__definition-tab"
        style={{
            right: !!selectedResult ? 0 : -300,
            width: !!selectedResult ? '100%' : 0,
        }}
    >
        <div className="header--close" onClick={() => closeResult()}></div>
        <h3>{selectedResult.name}</h3>
        <hr />
        <p>{selectedResult.definition}</p>
    </div>
);


GlossaryDefinitionTab.propTypes = {
    closeResult: PropTypes.func.isRequired,
    selectedResult: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
};

const mapStateToProps = state => ({
    selectedResult: state.glossary.selectedResult,
});

const mapDispatchToProps = dispatch => ({
    closeResult: () => dispatch(resultClosed()),
});

module.exports = connect(mapStateToProps, mapDispatchToProps)(GlossaryDefinitionTab);
